module.exports = __webpack_public_path__ + "img/3E3D39_D6CEAF_91BAC1_897966-256px.5e762e2a.png";